{
    "form_title": "Nouveau contact",
    "form_sub_title": "Elle sera enregistrée dans le système ERP et visible par tous",

    "form_label__title": "Civilité",
    "form_label__first_name": "Prénom",
    "form_label__last_name": "Nom",
    "form_label__email": "E-mail",
    "form_label__phone": "Téléphone",
    "form_label__mobile": "Mobile",
    "form_label__fax": "Fax",

    "form_placeholder__title": "M.",
    "form_placeholder__first_name": "Jean",
    "form_placeholder__last_name": "Dupont",
    "form_placeholder__email": "j.dupont@email.ch",
    "form_placeholder__phone": "022 345 67 89",
    "form_placeholder__mobile": "079 123 45 67",
    "form_placeholder__fax": "022 345 67 90"
}
